"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eDocs = void 0;
var eDocs = {
  name: 'e',
  category: 'Constants',
  syntax: ['e'],
  description: 'Euler\'s number, the base of the natural logarithm. Approximately equal to 2.71828',
  examples: ['e', 'e ^ 2', 'exp(2)', 'log(e)'],
  seealso: ['exp']
};
exports.eDocs = eDocs;